import * as React from "react"

const RweTop = (props) => (
    <div style={{width:"100%"}}>

        <svg
            width={896}
            height={815}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 896 815`}
            {...props}
        >
            <path
                d="M475 482c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32Z"
                fill="#F72585"
            />
            <path
                d="M407 443c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25Z"
                fill="#B5179E"
            />
            <path
                d="M418 450c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
                fill="#B5179E"
            />
            <path
                d="M485 392c14.359 0 26-11.641 26-26s-11.641-26-26-26-26 11.641-26 26 11.641 26 26 26ZM399 351c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24ZM380 478c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
                fill="#F72585"
            />
            <text
                fill="#FAFAFA"
                xmlSpace="preserve"
                style={{
                    whiteSpace: "pre",
                }}
                fontFamily="Poppins"
                fontSize={26}
                letterSpacing="0em"
            >
                <tspan x={350.337} y={420.6}>
                    {props.lang === "es" ? "PACIENTES": "PATIENTS"}
                </tspan>
            </text>
        </svg>
    </div>

)

export default RweTop
